import * as React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  List,
  ListItem,
  Typography,
  useMediaQuery
} from '@mui/material'
import Btn from '../Btn'

import check from '../../assets/images/check.svg'
import plus from '../../assets/images/plus.svg'
import minus from '../../assets/images/minus.svg'
import { categoryColor } from '../../theme/customColors'

import { useDispatch, useSelector } from 'react-redux'
import { closeCategories } from '../../redux/features/productCategoriesSlice'
import { type IServicesList } from '../../utils/serviceList'
import advertising from '../../assets/images/advertising.svg'
import { useNavigate } from 'react-router-dom'
import { PATH } from '../../routes/constant'

const AccordionHeading = styled(AccordionSummary)(({ theme }) => ({
  alignItems: 'center',
  borderRadius: '5px',
  overflow: 'hidden',
  position: 'relative',
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  [theme.breakpoints.down('lg')]: {
    padding: '20px'
  },
  [theme.breakpoints.only('lg')]: {
    padding: '30px'
  },
  [theme.breakpoints.up('xl')]: {
    padding: '40px'
  }
}))
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const ServicesAdsMock: React.FC = ({ servicesList }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const categoryState = useSelector((state: any) => state.productCategoriesState)
  const ref = React.useRef<HTMLDivElement>(null)

  const scrollToElement = () => {
    ref.current?.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  React.useEffect(() => {
    const timer = setTimeout(() => {
      scrollToElement()
    }, 200)
    return () => {
      clearTimeout(timer)
    }
  }, [categoryState])

  const adsMock = [
    {
      bg: categoryColor[4],
      iconUrl: advertising,
      title: 'Advertising',
      category: 'advertising',
      description: 'Drive Lead Opportunities by Promoting Your Business. Supercharge with Animated Ads! Customized or branded carousel ads with up to 5 images to highlight more aspects of your listing or features of your business.',
      plans: []
    }
  ]

  const featuresMock = [
    'Supercharge with Animated Ads',
    'We’ll design custom graphics or animated ads',
    'Branded carousel ads with up to 5 images',
    'Feature any message, event, special requests, promotion, etc.'
  ]

  return (
    <>
        {adsMock?.map((item: IServicesList) => {
          const {
            bg,
            iconUrl,
            title,
            description
          } = item
          const [isOpen, setIsOpen] = React.useState<false | true>(false)
          return (
          <Accordion
            ref = {(categoryState.offerTitle === title) ? ref : null}
            expanded={isOpen || categoryState.offerTitle === title}
            autoFocus={categoryState.offerTitle === title}
            onChange={(e: React.SyntheticEvent, expanded: boolean) => {
              if (categoryState.offerTitle === title) {
                dispatch(closeCategories())
              }
              setIsOpen(expanded)
            }}
            key={title}
            sx={{
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              background: 'linear-gradient(196.77deg, rgba(255, 255, 255, 0.85) 0, rgba(255, 255, 255, 0.85) 100%), ' + bg,
              borderRadius: '10px',
              overflow: 'hidden',
              marginBottom: '20px',
              position: 'relative'
            }}
          >
            <AccordionHeading>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                  [theme.breakpoints.only('lg')]: {
                    width: 'calc(100% - 115px)'
                  }
                }}
              >
                <Box
                  component='img'
                  src={iconUrl}
                  sx={{
                    [theme.breakpoints.down('lg')]: {
                      height: '43px',
                      marginRight: '30px',
                      width: '43px'
                    },
                    [theme.breakpoints.only('lg')]: {
                      height: '52px',
                      marginRight: '15px',
                      width: '52px'
                    },
                    [theme.breakpoints.up('xl')]: {
                      height: '52px',
                      marginRight: '50px',
                      width: '52px'
                    }
                  }}
                />
                <Box>
                  <Typography sx={{ color: theme.palette.grey[40], fontWeight: 500, marginBottom: '5px' }} variant='h4'>{title}</Typography>
                  {isDesktop && (
                    <Typography
                      sx={{
                        color: theme.palette.grey[70],
                        fontWeight: 400,
                        lineHeight: '20px',
                        maxWidth: '484px'
                      }}
                      variant='h5'
                    >
                      {description}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row'
                }}
              >
                <Box
                  component='img'
                  src={isOpen ? minus : plus}
                  sx={{
                    height: '13px',
                    marginRight: '10px',
                    width: '13px'
                  }}
                />
                <Typography sx={{ color: 'rgba(51, 68, 102, 0.7)', fontSize: '14px', fontWeight: 500 }}>
                  {isOpen ? 'Hide Options' : 'View Options'}
                </Typography>
              </Box>
            </AccordionHeading>
            <AccordionDetails>
                  <Box component='div'>
                    {isMobile && (
                      <Typography sx={{ color: theme.palette.grey[70], fontWeight: 400, lineHeight: '20px', mb: '30px' }} variant='h5'>{description}</Typography>
                    )}
                    <Box
                      sx={{
                        background: 'white',
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        marginBottom: '15px',
                        position: 'relative',
                        '&:before': {
                          background: bg,
                          content: '""',
                          height: '100%',
                          left: 0,
                          position: 'absolute',
                          rotate: '-180deg',
                          top: 0,
                          width: '8px'
                        },
                        [theme.breakpoints.down('lg')]: {
                          alignItems: 'top',
                          flexDirection: 'column',
                          p: '16px 22px'
                        },
                        [theme.breakpoints.only('lg')]: {
                          alignItems: 'center',
                          p: '20px 40px'
                        },
                        [theme.breakpoints.up('xl')]: {
                          alignItems: 'center',
                          p: '30px 80px'
                        }
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          [theme.breakpoints.down('lg')]: {
                            alignItems: 'baseline',
                            justifyContent: 'space-between'
                          },
                          [theme.breakpoints.up('lg')]: {
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%'
                          }
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            [theme.breakpoints.down('lg')]: {
                              alignItems: 'top'
                            },
                            [theme.breakpoints.up('lg')]: {
                              alignItems: 'center'
                            }
                          }}
                        >
                          {isDesktop && (
                              <Box sx={{ mr: '40px', minWidth: '200px', maxWidth: '200px' }}>
                                <Typography
                                    sx={{ color: theme.palette.grey[40] }}
                                    variant='h4'
                                >
                                  Facebook Ads
                                </Typography>
                                <Typography
                                    sx={{
                                      color: '#ADB8CC', fontSize: 13, fontWeight: 300
                                    }}
                                >
                                    Variable Pricing
                                </Typography>
                              </Box>
                          )}
                          {isMobile && (
                              <Box sx={{ minWidth: '200px', maxWidth: '200px' }}>
                                <Typography
                                    sx={{ color: theme.palette.grey[40] }}
                                    variant='h4'
                                >
                                  Facebook Ads
                                </Typography>
                                <Typography
                                    sx={{
                                      color: '#ADB8CC', fontSize: 13, fontWeight: 300
                                    }}
                                    variant='h5'
                                >
                                  Variable Pricing
                                </Typography>
                              </Box>
                          )}
                          {isDesktop && (
                            <List>
                              {featuresMock.map((item: any, index: any) => (
                                <ListItem key={index} sx={{ color: theme.palette.grey[70], fontSize: 14, fontWeight: 400, p: '5px 0' }}>
                                  <Box
                                    component='img'
                                    src={check}
                                    sx={{
                                      height: '9px',
                                      marginRight: '11px',
                                      width: '10px'
                                    }}
                                  />
                                  {item}
                                </ListItem>
                              ))}
                            </List>
                          )}
                        </Box>
                        {
                           isDesktop && (<Btn
                                onClick={() => { navigate(PATH.SUPPORT_CREATE, { state: { subject: 'Interested in Adding Facebook Ads', reason: 9, description: ' ' } }) }}
                                variant='outlined'
                                color='primary'
                                text={'Interested in Ads? Contact Us'}
                                sx={{ color: theme.palette.grey[40], minWidth: '246px', p: '22px 11px' }}/>
                           )
                        }
                      </Box>
                      {isMobile && (
                        <List sx={{ p: 0, m: '30px 0 20px' }}>
                          {featuresMock.map((item: any, index: any) => (
                            <ListItem key={index} sx={{ color: theme.palette.grey[70], fontSize: 14, fontWeight: 400, p: '5px 0' }}>
                              <Box
                                component='img'
                                src={check}
                                sx={{
                                  height: '9px',
                                  marginRight: '11px',
                                  width: '10px'
                                }}
                              />
                              {item}
                            </ListItem>
                          ))}
                        </List>
                      )}
                      {
                          isMobile && (<Btn
                                onClick={() => { navigate(PATH.SUPPORT_CREATE, { state: { subject: 'Interested in Adding Facebook Ads', reason: 9, description: ' ' } }) }}
                                variant='outlined'
                                color='primary'
                                text={'Interested in Ads? Contact Us'}
                                sx={{ color: theme.palette.grey[40], width: 'max-content', maxWidth: '-webkit-fill-available', fontSize: '12px', p: '9px 6px', minHeight: '38px' }}/>
                          )
                      }
                    </Box>
                  </Box>
            </AccordionDetails>
          </Accordion>
          )
        })}
    </>
  )
}

export default ServicesAdsMock
